import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import LoadImage from "./load";
import VideoSearch from "./video_search";
import LoadImages from "./load_images";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
    <BrowserRouter>
      <Routes>
          {/*<Route path="/load" element={<LoadImage/>} />*/}
          <Route path="/load_images" element={<LoadImages/>} />
          <Route path="/video_search" element={<VideoSearch/>} />
          <Route path="/" element={<App />}>
          </Route>
      </Routes>
    </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
